import axios from 'axios';
import {interceptorsFn} from './request.utils'
import qs from 'qs'
import {getBrowserLanguage, getQueryVariable, getBrowserDefaultLanguage, isMobile, isValidIP, /* updateProp,
  storageGetItem, storageRemoveItem, storageSetItem, getCurrentCommitId */} from '../utils/utils'
import {browserVersion} from 'Utils/browser-info'
import { store } from 'Store/store.index';
// import { isPdfOnlineDomain } from 'Utils/utils'
import * as API_CONSTANTS from './constants';
import { HttpRequest } from './request.utils';
const prop = (obj, attr) => obj[attr];

interceptorsFn(axios);
let browserLang = getBrowserDefaultLanguage();
let _isMobile = isMobile()

class BaseUrlApis extends HttpRequest{
  constructor() {
    super();
    this.CPDFURI                = '';
    this.cfgPromise             = null;
    this.onlinePromise          = null;
    this.server_config          = this.getQueryVariable('server_config');

    this.initialize             = this.initialize.bind(this);
    this.getQueryVariable       = this.getQueryVariable.bind(this);
    this.getCwsBaseUrlByBaseUrl = this.getCwsBaseUrlByBaseUrl.bind(this);
    // this.loadUrlConfig          = this.loadUrlConfig.bind(this);
    this.getBaseUrlBy           = this.getBaseUrlBy.bind(this);
    this.getServerInfo          = this.getServerInfo.bind(this);


  }

  initialize(){
    try {
        this.getBaseUrlBy(API_CONSTANTS.URL_CWS_API).then((data) => {
            this.CPDFURI = data;
            // 8003 8081
            //this.CPDFURI = 'http://10.103.4.236:8003';
            let axiosClient = axios.create({
                baseURL: this.CPDFURI,
            });
            super.initialize(axiosClient, () => {
                this.interceptorsFn();
            });
            //interceptorsFn(this.apisAxios);
        });
    } catch (error) {
        throw error;
    }
  }

  getQueryVariable(variable){
    return getQueryVariable(variable);
  };

  getBaseUrl = (noPort) => {
    const href = prop(location, 'href')
    const port = prop(location, 'port')
    let path = prop(location, 'pathname');
    let startPos = prop(location, 'protocol').length + 2;
    let pos = href.indexOf(path, startPos);
    let host = href.substring(0, pos);
    let baseUrl = host + '/';

    if(noPort && port && port.length>0){
      baseUrl = baseUrl.replace(':' + port, '')
    }
    return baseUrl;
  };

  getBaseOrigin = () => {
    const href = prop(location, 'href')
    let path = prop(location, 'pathname');
    let startPos = prop(location, 'protocol').length + 2;
    let pos = href.indexOf(path, startPos);
    let host = href.substring(0, pos);

    return host;
  };

  getCwsBaseUrlByBaseUrl(){
    // https://jira.foxitsoftware.cn/browse/PRO-6537
    //! 接口需要处理为云编辑。
    let baseUrl = this.getBaseUrl(true);
    let isIp = isValidIP(baseUrl);
    let port = prop(location, 'port');
    //!  本地或测试环境访问接口处理
    if (baseUrl.indexOf('localhost') !== -1 || port !== '' || isIp || baseUrl.indexOf('http://online-fz08') !== -1) {
      baseUrl = 'https://pheecws-azk8s.foxitcloud.com/';
    } else if (baseUrl.indexOf("online-azk8s.connectedpdf.com") !== -1 || baseUrl.indexOf(".online-azk8s.foxitcloud.com") !== -1) {
      baseUrl = 'https://pheecws-azk8s.foxitcloud.com/';
    }else if(baseUrl.indexOf("devazk8s.connectedpdf.com") !== -1){
      baseUrl = 'https://pheecws-devazk8s.connectedpdf.com/';
    }

    if (baseUrl.indexOf('http://') !== -1) {
      baseUrl = baseUrl.replace('http://', 'https://');
    }
    // be used for develop env
    if(!!this.server_config){
      const URLS = {
        'demo4': 'https://pheecws-demo4.connectedpdf.com/',
        'p-demo': 'https://pheecws-demo4.connectedpdf.com/',
        'fzk8s':'https://pheecws-fzk8s.connectedpdf.com/',
        'fzk8s01':'https://pheecws-fzk8s01.connectedpdf.com/',
        'pdfonline':'https://pheecws.foxit.com/',
        'online_cn':'https://pheecws.foxitsoftware.cn/',
        'azk8s': 'https://pheecws-azk8s.foxitcloud.com/',
        'stgjp': 'https://pheecws-stgjp.connectedpdf.com/',
        'stgus': 'https://pheecws-stgus.connectedpdf.com/',
        'stgca': 'https://pheecws-stgca.connectedpdf.com/',
        'devazk8s': 'https://pheecws-devazk8s.connectedpdf.com/',
        'euazk8s': 'https://pheecws-euazk8s.connectedpdf.com/',
        'caazk8s': 'https://pheecws-caazk8s.connectedpdf.com/'
      }
      let url = URLS[this.server_config];
      if(!!url){
        return url;
      }
    }
    // ONLINERD-11714, DingTalk domain test
    if (baseUrl.includes('.eapps.dingtalkcloud.com')) {
      return 'https://pheecws.foxitsoftware.cn/';
    }

    // phee: online.foxitsoftware.cn => pheecws.foxitsoftware.cn
    // phee: pdfonline.foxitsoftware.com => pheecws.foxitsoftware.com
    // online.foxitsoftware.cn => pheecws.foxitsoftware.cn
    // https://pheeadmin-fzk8s.connectedpdf.com/api/server-config

    let url = baseUrl.replace(/\/\/\w+\-/, '//pheecws-');
    if(url.indexOf('pheecws') !== -1){
      return url;
    }
    url = baseUrl.replace(/\/\/\w+\./, '//pheecws.');
    return url;
  }
  checkAiPluginNetWork = async () => {
    const {foxitAiPluginUrl} = store.appStore

    if(!foxitAiPluginUrl) {
      return false
    }

    const result = await axios.get(`${foxitAiPluginUrl}/version.txt?dt=${new Date().getTime()}`)

    return result
  }
  setCheckOfflineTimer(){
    let timer;
    clearInterval(timer);
    timer = setInterval(()=>{
      this.checkOffline().then(()=>{})
    },300000)
  }

  checkOffline = () => {
    // if(this.onlinePromise){
    //   return this.onlinePromise;
    // }
    this.onlinePromise = new Promise( (resolve)=>{
      let onlineUrl = this.getBaseUrl();
      let url = onlineUrl + 'robots.txt?v=' + new Date().valueOf();
      axios.get(url).then(()=>{
        // updateProp(window, '__online__', true);
        return resolve(true)
      }).catch(()=>{
        // updateProp(window, '__online__', false);
        return resolve(false);
      })
    })
    return this.onlinePromise;
  };

  // ! 获取全局的配置
  getServerConfig = (success, error) => {
    success({});
    error && error({});
    // let cwsBaseUrl = this.getCwsBaseUrlByBaseUrl();

    // // https://pheeadmin-fzk8s.connectedpdf.com/api/server-config
    // // https://cws-fzk8s.connectedpdf.com/cpdfapi/v1/server/server-config
    // // https://pheecws-fzk8s.connectedpdf.com/cpdfapi/v1/server/server-config
    // //let url = cwsBaseUrl + "cpdfapi/v1/server/server-config?v="+(new Date()).valueOf();
    // let url = cwsBaseUrl + 'cpdfapi/v1/server/server-config?v=' + new Date().valueOf();
    // return axios.get(url).then((result) => {
    //   if (result && result.ret === 0) {
    //     const { data } = result;
    //     success && success(data);
    //     return data;
    //   }
    //   error && error(result);
    //   console.error('TCL: BaseUrlManage -> getServerConfig -> response', result);
    //   return null;
    // }).catch((err) => {
    //   console.error('TCL: getServerConfig -> err', err);
    //   error && error(err);
    //   return null;
    // });
  };
  getCloudConfig = (success, error) => {
    let baseUrl = this.getBaseUrl();

    // https://pheeadmin-fzk8s.connectedpdf.com/api/server-config
    // https://cws-fzk8s.connectedpdf.com/cpdfapi/v1/server/server-config
    // https://pheecws-fzk8s.connectedpdf.com/cpdfapi/v1/server/server-config
    //let url = cwsBaseUrl + "cpdfapi/v1/server/server-config?v="+(new Date()).valueOf();
    let url = baseUrl + 'cloud.json?v=' + new Date().valueOf();
    axios.get(url).then(() => {

      })
      .catch((err) => {
        console.error('TCL: getServerConfig -> err', err);
        error(err);
      });
  };

  // !云编辑去除
  // loadUrlConfig(){
  //   //    获取所有接口的配置 URL
  //   if (this.cfgPromise) {
  //     return this.cfgPromise;
  //   }
  //   this.setCheckOfflineTimer()
  //   this.checkOffline();
  //   if (window.localStorage) {
  //     let timestamp = storageGetItem(localStorage, 'config-timestamp') ||0;
  //     const nowTime = Date.now();
  //     let countDay = (nowTime - timestamp) / (1000 * 60 * 60 * 24) >>> 0;
  //     if (countDay>1) {
  //       storageRemoveItem(localStorage, API_CONSTANTS.PHANTOMONLINE_GLOBAL_CONFIG);
  //       storageSetItem(localStorage, 'config-timestamp', nowTime);
  //     }
  //   }
  //   let _this = this;
  //   this.cfgPromise = new Promise((resolve, reject) => {
  //     const currentCommitId = getCurrentCommitId()

  //     // load from localStorage
  //     if(!_this.server_config){
  //       try {
  //         const storageCommitId = storageGetItem(localStorage, API_CONSTANTS.COMMIT_ID);
  //         let szCfg = storageGetItem(localStorage, API_CONSTANTS.PHANTOMONLINE_GLOBAL_CONFIG);

  //         // localStorage里存在CommitID，并且与当前online的版本一直才使用localStorage里的PHANTOMONLINE_GLOBAL_CONFIG
  //         if (storageCommitId && storageCommitId !== 'undefined' && JSON.parse(storageCommitId) === currentCommitId && szCfg) {
  //           let cfg = JSON.parse(szCfg);
  //           window[API_CONSTANTS.PHANTOMONLINE_GLOBAL_CONFIG] = cfg;
  //           //appStore.setPhantomOnlineGlobalConfig(cfg)
  //           return resolve(cfg);
  //         }
  //       } catch (e) {
  //         console.error(e);
  //       }
  //     }
  //     //
  //     _this.getServerConfig(
  //       (data) => {
  //         if(!data){
  //           _this.cfgPromise = null;
  //           return;
  //         }

  //         //ONLINERD-1301
  //         let isDebug = this.getQueryVariable('debug');
  //         const platform = this.getQueryVariable('platform')


  //         console.log(platform);

  //         if (!isDebug && (isPdfOnlineDomain() || isTestDomainForTeams()) && data && data.userCountry && data.userCountry.toLowerCase()  === "japan") {
  //           const onlineJPUrl = data.onlineJPUrl

  //           if (platform === 'Teams') {
  //             const searchUrl = prop(window.location, 'search')

  //             windowActionFn(window, 'open', [`${onlineJPUrl}/${searchUrl}`, '_self'])
  //           } else {
  //             windowActionFn(window, 'open', [onlineJPUrl, '_self'])
  //           }
  //           return;
  //         }

  //         window[API_CONSTANTS.PHANTOMONLINE_GLOBAL_CONFIG] = data;

  //         storageSetItem(localStorage, API_CONSTANTS.COMMIT_ID, JSON.stringify(currentCommitId))
  //         storageSetItem(localStorage, API_CONSTANTS.PHANTOMONLINE_GLOBAL_CONFIG, JSON.stringify(data));
  //         return resolve(data);
  //       },
  //       (err) => {
  //         _this.cfgPromise = null;
  //         return reject(err);
  //       },
  //     );
  //   });
  //   return _this.cfgPromise;
  // };

  async getBaseUrlBy(key) {
    // let urlCfg = await this.loadUrlConfig();
    let urlCfg = {}
    return new Promise((resolve, /* reject */) => {
      switch (key) {
        case API_CONSTANTS.URL_CWS_API:
        case API_CONSTANTS.URL_APPSTORE_API:
        case API_CONSTANTS.URL_CLOUD_API:
        case API_CONSTANTS.URL_PLATFORM:
        case API_CONSTANTS.URL_ESIGNCN:
        case API_CONSTANTS.URL_FOXIT_SIGN:
        case API_CONSTANTS.URL_IDOX_API:
        case API_CONSTANTS.URL_ACCOUNT:
        case API_CONSTANTS.URL_CMIS:
          resolve(urlCfg[key]);
          break;
        default:
          throw 'not valid key' + key;
      }
    });
  }

  async getDrivesConfig({ enterprise_id, /* success, fail */ }) {
    let cwsBaseUrl = await this.getBaseUrlBy(API_CONSTANTS.URL_CWS_API);
    return new Promise((resolve, reject) => {
      let url = cwsBaseUrl + '/cpdfapi/v1/server/enterprise-config?v=' + new Date().valueOf();
      axios.get(url, {params: { enterprise_id, }}).then((result) => {
        const { ret } = result;
        if (ret === 0) {
          resolve(result);
          return;
        }
        reject(result);

      }).catch((err) => {
        console.error('TCL: getDrivesConfig -> err', err);
        reject(err);
      });

    })
  }

  getServerInfo(success, error){
    //https://pheecws-docker.connectedpdf.com/cpdfapi/v1/server/display-name?sdfwerwer
    let cwsBaseUrl = this.getCwsBaseUrlByBaseUrl();

    // https://pheeadmin-fzk8s.connectedpdf.com/api/server-config
    // https://cws-fzk8s.connectedpdf.com/cpdfapi/v1/server/server-config
    // https://pheecws-fzk8s.connectedpdf.com/cpdfapi/v1/server/server-config
    //let url = cwsBaseUrl + "cpdfapi/v1/server/server-config?v="+(new Date()).valueOf();
    let lng = getBrowserLanguage();
    let request = qs.stringify({
      from:'online',
      v: new Date().valueOf(),
      al: lng.full,
      an: 'Foxit PhantomPDF Online'
    });
    let url = cwsBaseUrl + `cpdfapi/v1/server/display-name?${request}`;
    axios.get(url).then((result) => {
      const { message } = result;
      if (result.ret === 0) {
        success(message);
        return;
      }
      error && error(result);

    }).catch((err) => {
      console.error('TCL: getServerInfo -> err', err);
      error && error(err);
    });
  }

  fetchRegularFont(){
    //'https://online-fzk8s.connectedpdf.com/foxitwebsdk/external/brotli/NotoSansMonoCJKsc-Regular.otf.brotli'

    let fontName = 'NotoSansMonoCJKsc-Regular.otf'
    if(!window.__sdkFontsHash__)return;
    let hash = window.__sdkFontsHash__[fontName];
    if(!hash)return;
    let baseUrl = API_CONSTANTS.FOXITWEBSDK_URLS.fontPath +`/${fontName}.brotli?h=${hash}`;
    axios.get(baseUrl).then((/* result */)=>{

    })
  }

  fetchStamps(){
    //https://online-fzk8s.connectedpdf.com/foxitwebsdk/lib/stamps/zh-CN/StandardStamps/Approved.pdf
    // const {isCN} = store.appStore;
    // let lng = 'en-US'
    // if(isCN)lng = 'zh-CN'
  }

  getUpdateLogs = (success, error) => {
    let baseUrl = this.getBaseUrl();

    // https://xxx/notes/history.json

    let url = baseUrl + 'notes/history.json?v=' + new Date().valueOf();
    return axios.get(url).then((result) => {

      success && success(result)
      return result;
    }).catch((err) => {
      console.error('TCL: BaseUrlManage -> getUpdateLogs -> err', err);
      error && error(err);
      return {}
    });
  };
  getUpdateLog = (fileName, success, error) => {
    let baseUrl = this.getBaseUrl();

    // https://xxx/notes/history.json

    let url = baseUrl + `notes/${fileName}?v=` + new Date().valueOf();
    return axios.get(url).then((result) => {

      if(result.indexOf('<!doctype html>')!== -1){
        throw Error('404');
      }
      success && success(result)
      return result;
    }).catch((err) => {
      console.error('TCL: BaseUrlManage -> getUpdateLogs -> err', err);
      error && error(err);
      throw err;
    });
  };

  async sendErrorLog(list){
    let cwsBaseUrl = await this.getBaseUrlBy(API_CONSTANTS.URL_CWS_API);
    //https://pheecws-fzk8s.connectedpdf.com/cpdfapi/v1/client/exception-log
    let url = `${cwsBaseUrl}/cpdfapi/v1/client/exception-log`;
    let _time = new Date().toISOString();
    const {userId} = store.userStore;
    const {actions} = store.appStore;
    //var error = { id: _errId, type: error.category, data: error.data, browserId };
    let data = list.map((errItem)=>{
      //{ "application": "PhantomPDF Online", "time": "2020-10-12 07:39:35", "level": "error", "message": "log desc", "module": "user", "user": "userid" }
      let _subItem = {
        "application": "PhantomPDF Online",
        "time":_time,
        "level": errItem.level?errItem.level: "error",
        "message": JSON.stringify(errItem.data),
        "module": errItem.type,
        "user": userId,
        "browserId": errItem.browserId,
        "browserVersion": browserVersion,
        "browserLang": browserLang,
        "ua":navigator.userAgent,
        "isMobile": _isMobile,
        "actions":JSON.stringify(actions)
      }

      return _subItem;
    })
    if(navigator.onLine === false){
      console.error("Network offline: sendErrorLog -> {url, data}", {url, data})
      return;
    }
    try {
      this.post({url, data}).catch((err)=>{
        console.error("sendErrorLog -> err", err)
      });
    } catch (error) {
      console.error("sendErrorLog -> error", error)
    }

  }
  foxitSignAuthStatus = async (JWT, companyId) => {
    let url = `/cpdfapi/v1/client/request`;
    const { token, roleInfo } = store.userStore

    let request_csrf = new Date().getTime();
    let storageKeyPrefix = 'FoxitSignAuthStatus';

    const params = {
      JWT: encodeURI(JWT),
      'access-token': token,
      dist: 'SIGN',
      _csrf: request_csrf,
      companyId
    }

    let enterpriseId = '';
    if (roleInfo) {
      ({ enterpriseId } = roleInfo);

      Object.assign(params, {enterpriseId})
    }

    try {
      const result = await this.get({ url, config: { 
        params,
      }});
      if (result) {
        let { ret } = result;
        if ((ret === 0) || (ret >=50000 && ret <= 59999)) {
          saveClientRequestStatusToCache(result, request_csrf, enterpriseId, storageKeyPrefix)
          return Promise.resolve(result)
        } else {
          return getClientRequestStatusFromCache(enterpriseId, storageKeyPrefix).then( res => {
            if (res) {
              return Promise.resolve(res)
            }
            return Promise.resolve(result)
          })
        }
      } else {
        return Promise.resolve(result)
      }
    } catch (error) {
      return getClientRequestStatusFromCache(enterpriseId, storageKeyPrefix).then( res => {
        if (res) {
          return Promise.resolve(res)
        }
        return Promise.reject(error)
      })
    }
  }
  getEsignEnterpriseUserCompanyId = async () => {
    let url = '/cpdfapi/v1/enterprise/esign-company';
    const { token, roleInfo } = store.userStore;
    try {
      const result = await this.get({ url, config: { 
        params: {
          'access-token': token,
          enterpriseId: roleInfo.enterpriseId
        }
      }});
      if (result) {
        let { ret, data } = result;
        if (ret == 0 && data) {
          return Promise.resolve(data.companyId);
        }
      }
      return Promise.reject('Query eSign Enterprise User CompanyId error!');
    } catch (err) {
      return Promise.reject(err);
    }
  }
  getUserInfoByToken = async (token) => {
    let url = '/cpdfapi/v1/users/user-by-token';
    try {
      const result = await this.get({ url, config: { 
        params: {
          'access-token': token
        }
      }});
      if (result) {
        return Promise.resolve(result);
      }
      return Promise.reject('GetUserInfoByToken error!');
    } catch (err) {
      return Promise.reject(err);
    }
  }
  getEnterpriseSetting = async (enterpriseId) => {
    let url = '/cpdfapi/v1/server/enterprise-setting';
    try {
      const result = await this.get({ url, config: { 
        params: {
          enterpriseId,
          dist: 'ONLINE'
        }
      }});
      if (result) {
        let { ret, data } = result;
        if (ret === 0 && data && Object.prototype.toString.call(data) === '[object Object]') {
          return Promise.resolve(data)
        }
      }
      return Promise.reject('GetEnterpriseSetting error!');
    } catch (err) {
      return Promise.reject(err);
    }
  }
}




export default BaseUrlApis;
